import { useQueryClient } from '@tanstack/react-query'
import { useEffect, useState } from 'react'

import { useCustomerFormStore } from '@/modules/customer/stores/customer-form.store'
import { QUERY_KEYS } from '@/modules/shared/constants/query-keys.contant'
import { useMainStore } from '@/modules/shared/stores/main.store'

import {
  useOrderFormStore,
  useOrderFormStoreActions,
} from '../stores/order-form.store'
import type { IOrderFormJson } from '../types/order-form-json.type'
import type { TOrderFormParams } from '../types/order-form-params.type'
import { useOrderFormCalculation } from './use-order-form-calculation.hook'
import { useOrderFormGetOperationsQuery } from '../querys/order-form-get-operations.query'

export const useOperationOrder = () => {
  const [companyId, setCompanyId] = useState<string | undefined>(undefined)

  const queryClient = useQueryClient()

  const { calculateOrderForm } = useOrderFormCalculation()

  const { paramsOrderForm, jsonOrderForm, operationType } = useOrderFormStore()
  const { isCustomerStartedOrder } = useMainStore()
  const { clientSelected } = useCustomerFormStore()
  const { setIsCustomerStartedOrder } = useMainStore().actions

  const { setParamsOrderForm, setJsonOrderForm, setEntityTypeSelected } =
    useOrderFormStoreActions()

  const callback = (body: TOrderFormParams) => {
    const newOrderFormParams = {
      ...paramsOrderForm,
      listaOperacaoFisica: body.listaOperacaoFisica,
      listaOperacaoJuridica: body.listaOperacaoJuridica,
    }

    setParamsOrderForm(newOrderFormParams)

    const operationTypeOfOrder = {
      1: body?.listaOperacaoJuridica,
      2: body?.listaOperacaoFisica,
    }

    if (isCustomerStartedOrder) {
      const entityTypeSelected = clientSelected?.flagPessoa === '2' ? '1' : '2'

      const newJsonOrderForm: IOrderFormJson = {
        ...jsonOrderForm,
        fkCliente: String(clientSelected?.idEntidade),
        fkOperacao: String(
          operationTypeOfOrder[entityTypeSelected][0]?.idOperacao ?? '1',
        ),
        parametros: {
          ...jsonOrderForm.parametros,
          atualizaDadosCliente: operationType === 'add',
        },
      }
      setIsCustomerStartedOrder(false)
      setJsonOrderForm(newJsonOrderForm)
      setEntityTypeSelected(entityTypeSelected)

      calculateOrderForm(newJsonOrderForm)
    }
  }

  const { orderFormOperations, refetchOrderFormGetOperations } =
    useOrderFormGetOperationsQuery({
      companyId,
    })

  useEffect(() => {
    if (companyId !== undefined) {
      const cached = queryClient.getQueryData<TOrderFormParams>([
        QUERY_KEYS.ORDER_FORM_OPERATION,
        companyId,
      ])
      if (cached) {
        callback(cached)
      } else {
        refetchOrderFormGetOperations()
      }
    }
  }, [companyId, clientSelected?.idEntidade, operationType])

  useEffect(() => {
    if (orderFormOperations) {
      callback(orderFormOperations)
    }
  }, [orderFormOperations])

  return {
    setCompanyId,
  }
}
